var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Treeselect',{ref:"Treeselect",attrs:{"options":_vm.mailboxes,"multiple":false,"clearable":false,"disabled":_vm.disabled},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }